module.exports = "/_next/static/images/cableDesign1-8a2635b404d3fdbb831c25886c8049b0.webp";